export const BIRTHDAY_THEME_OPTIONS = [
  { id: 'romantic', label: 'Romantic' },
  { id: 'playful', label: 'Playful' },
  { id: 'classic', label: 'Classic' },
];

export const BIRTHDAY_DEFAULT_VALUES = {
  recipientName: '',
  senderName: '',
  birthdayDate: '',
  headline: 'Happy Birthday!',
  message: 'Wishing you joy, laughter, and all the love in the world on your special day.',
  closingMessage: 'May this year bring you beautiful moments and unforgettable memories.',
  theme: 'romantic',
};

export const BIRTHDAY_FIXED_MUSIC = '/birthday.mp3';

export const BIRTHDAY_THEME_COPY = {
  romantic: {
    countdownTitle: 'Your Special Day is Almost Here',
    revealButton: 'For you',
    cardPrompt: 'Tap to open your card',
  },
  playful: {
    countdownTitle: 'Party Countdown Starts Now',
    revealButton: 'Open surprise',
    cardPrompt: 'Tap to reveal your surprise',
  },
  classic: {
    countdownTitle: 'Counting Down to Celebration',
    revealButton: 'Open card',
    cardPrompt: 'Tap to open your birthday card',
  },
};
